import type { AppLang } from '../context/DirectionContext';

const T = {
  // ── Navigation ────────────────────────────────────────────────────────────
  'nav.dashboard':       { en: 'Dashboard',        he: 'לוח בקרה' },
  'nav.users':           { en: 'Users',            he: 'משתמשים' },
  'nav.cycles':          { en: 'Cycles',           he: 'מחזורים' },
  'nav.summary':         { en: 'Summary',          he: 'סיכום מחזורים' },
  'nav.formBuilder':     { en: 'Forms',            he: 'טפסים' },
  'nav.stationBuilder':  { en: 'Stations',         he: 'תחנות' },
  'nav.statements':      { en: 'Statements',       he: 'הצהרות' },
  'nav.parameters':      { en: 'Parameters',       he: 'פרמטרים' },
  'nav.unitInfo':        { en: 'Unit Info',        he: 'פרטי יחידה' },
  'nav.adminLabel':      { en: 'Admin',            he: 'ניהול' },
  'nav.signOut':         { en: 'Sign out',         he: 'התנתקות' },

  // ── Summary page masthead ─────────────────────────────────────────────────
  'page.breadcrumb':     { en: 'Analytics / Command Center', he: 'ניתוח / מרכז פיקוד' },
  'page.title':          { en: 'Command Center',             he: 'מרכז פיקוד' },
  'page.subtitle':       { en: 'Filter, compare, and adjudicate the active slate.', he: 'סנן, השווה והחלט על המצב הפעיל.' },
  'btn.export':          { en: 'Export',          he: 'ייצוא' },
  'btn.importCsv':       { en: 'Import CSV',      he: 'ייבוא CSV' },
  'btn.importImages':    { en: 'Import Images',   he: 'ייבוא תמונות' },
  'btn.clear':           { en: 'Clear',           he: 'נקה' },
  'btn.fullscreen':      { en: 'Full Screen',     he: 'מסך מלא' },
  'btn.exitFullscreen':  { en: 'Exit Full Screen', he: 'יציאה ממסך מלא' },
  'btn.resetZoom':       { en: 'Reset',           he: 'איפוס' },
  'banner.unsaved':      { en: 'Unsaved enrichment active', he: 'נתוני העשרה לא שמורים' },
  'banner.unsavedBody':  { en: 'CSV data is session-only. Export as JSON to persist.', he: 'נתוני CSV תקפים לסשן בלבד. ייצא כ-JSON לשמירה.' },
  'error.cycleLoad':     { en: 'Error loading cycle data',  he: 'שגיאה בטעינת נתוני מחזור' },
  'loading':             { en: 'Loading…',        he: 'טוען…' },

  // ── Candidate list panel ──────────────────────────────────────────────────
  'list.candidates':     { en: 'Candidates',      he: 'מועמדים' },
  'list.selectCycle':    { en: 'Select cycle…',   he: 'בחר מחזור…' },
  'list.searchPlaceholder': { en: 'Name or number… ⌘K', he: 'שם או מספר… ⌘K' },
  'list.noResults':      { en: 'No candidates match the filters.', he: 'אין מועמדים התואמים לפילטרים.' },
  'filter.allStatuses':  { en: 'All statuses',    he: 'כל הסטטוסים' },
  'filter.allTeams':     { en: 'All teams',       he: 'כל הצוותים' },
  'filter.team':         { en: 'Team',            he: 'צוות' },
  'filter.allMatams':    { en: 'All matams',      he: 'כל המתא"ם' },
  'filter.matam':        { en: 'Matam',           he: 'מתא"ם' },
  'filter.matamUnknown': { en: 'Unknown',         he: 'לא ידוע' },
  'filter.allEvaluators':{ en: 'All evaluators',  he: 'כל המעריכים' },
  'filter.sort':         { en: 'Sort',            he: 'מיון' },
  'filter.direction':    { en: 'Direction',       he: 'כיוון' },
  'filter.ascending':    { en: 'Ascending',       he: 'עולה' },
  'filter.descending':   { en: 'Descending',      he: 'יורד' },
  'filter.tier':         { en: 'Tier',            he: 'שכבה' },
  'filter.evaluator':    { en: 'Evaluator',       he: 'מעריך' },
  'filter.status':       { en: 'Status',          he: 'סטטוס' },
  'color.on':            { en: 'Colors on',       he: 'צבעים פועל' },
  'color.off':           { en: 'Colors off',      he: 'צבעים כבוי' },

  // ── Sort options ──────────────────────────────────────────────────────────
  'sort.score':          { en: 'Score',  he: 'ציון' },
  'sort.rank':           { en: 'Rank',   he: 'דירוג' },
  'sort.name':           { en: 'Name',   he: 'שם' },
  'sort.team':           { en: 'Team',   he: 'צוות' },

  // ── Tier labels ───────────────────────────────────────────────────────────
  'tier.all':            { en: 'All',    he: 'הכל' },
  'tier.top':            { en: 'Top',    he: 'עליון' },
  'tier.mid':            { en: 'Mid',    he: 'אמצעי' },
  'tier.bottom':         { en: 'Bot',    he: 'תחתון' },
  'tier.unknown':        { en: 'unknown', he: 'לא ידוע' },

  // ── Candidate status labels ───────────────────────────────────────────────
  'status.active':       { en: 'Active',     he: 'פעיל' },
  'status.withdrawn':    { en: 'Withdrawn',  he: 'נסוג' },
  'status.completed':    { en: 'Completed',  he: 'הושלם' },
  'status.incomplete':   { en: 'Incomplete', he: 'לא הושלם' },

  // ── Detail drawer ─────────────────────────────────────────────────────────
  'drawer.freeText':     { en: 'Free Text',                         he: 'טקסט חופשי' },
  'drawer.noFreeText':   { en: 'No free-text answers.',             he: 'אין תשובות טקסט חופשי.' },
  'drawer.numericalParams': { en: 'Numerical Parameters',           he: 'פרמטרים מספריים' },
  'drawer.noNumericalParams': { en: 'No numerical parameters.',     he: 'אין פרמטרים מספריים.' },
  'drawer.empty':        { en: 'Select a candidate to view details', he: 'בחר מועמד לצפייה בפרטים' },
  'drawer.candidateNumber': { en: 'Candidate #',   he: 'מועמד מספר' },
  'drawer.rankUnknown':  { en: 'Rank unknown',   he: 'דירוג לא ידוע' },
  'drawer.rankLabel':    { en: 'Rank',            he: 'דירוג' },
  'drawer.rankedBy':     { en: 'Ranked by',       he: 'דורג ע"י' },
  'drawer.redFlag':      { en: 'Red Flag',        he: 'דגל אדום' },
  'drawer.scoreBreakdown':{ en: 'Score Breakdown', he: 'פירוט ציונים' },
  'drawer.partial':      { en: 'Partial',         he: 'חלקי' },
  'drawer.rating':       { en: 'Rating',          he: 'דירוג' },
  'drawer.noData':       { en: 'No data.',         he: 'אין נתונים.' },
  'drawer.concerns':     { en: 'Concerns & Red Flags', he: 'חששות ודגלים אדומים' },
  'drawer.noConcerns':   { en: 'No concerns raised.',  he: 'לא הועלו חששות.' },
  'drawer.details':      { en: 'Candidate Details',    he: 'פרטי מועמד' },
  'drawer.inactivationReason': { en: 'Inactivation Reason', he: 'סיבת ביטול' },
  'drawer.note':         { en: 'Note',                 he: 'הערה' },
  'drawer.lastStatus':   { en: 'Last Status Change',   he: 'שינוי סטטוס אחרון' },
  'drawer.matam':        { en: 'Matam',                 he: 'מתא"ם' },
  'drawer.csvEnriched':  { en: 'CSV Enriched',         he: 'נתוני העשרה' },
  'drawer.noDetails':    { en: 'No additional details.', he: 'אין פרטים נוספים.' },

  // ── Score labels ─────────────────────────────────────────────────────────
  'score.final':         { en: 'Final',      he: 'סופי' },
  'score.socio':         { en: 'Socio',      he: 'סוציו' },
  'score.assessment':    { en: 'Assessment', he: 'גיבוש' },
  'score.interview':     { en: 'Interview',  he: 'ראיון' },
  'score.commander':     { en: 'Cmd',        he: 'מפקד' },

  // ── Common actions ────────────────────────────────────────────────────────
  'common.cancel':       { en: 'Cancel',      he: 'ביטול' },
  'common.close':        { en: 'Close',       he: 'סגור' },
  'common.back':         { en: 'Back',        he: 'חזרה' },
  'common.skip':         { en: 'Skip',        he: 'דלג' },
  'common.next':         { en: 'Next',        he: 'הבא' },
  'common.finish':       { en: 'Finish',      he: 'סיים' },
  'common.save':         { en: 'Save Changes', he: 'שמור שינויים' },
  'common.add':          { en: 'Add',         he: 'הוסף' },
  'common.edit':         { en: 'Edit',        he: 'ערוך' },
  'common.delete':       { en: 'Delete',      he: 'מחק' },
  'common.view':         { en: 'View',        he: 'צפה' },
  'common.activate':     { en: 'Activate',    he: 'הפעל' },
  'common.upload':       { en: 'Upload CSV',  he: 'העלה CSV' },
  'common.mgmt':         { en: 'Management',  he: 'ניהול' },
  'common.required':     { en: 'Required',    he: 'שדה חובה' },
  'common.notSet':       { en: 'Not set',     he: 'לא הוגדר' },
  'common.yes':          { en: 'Yes',         he: 'כן' },
  'common.no':           { en: 'No',          he: 'לא' },
  'common.roles':        { en: 'Roles',       he: 'תפקידים' },
  'common.role':         { en: 'Role',        he: 'תפקיד' },
  'common.email':        { en: 'Email',       he: 'אימייל' },
  'common.name':         { en: 'Name',        he: 'שם' },
  'common.status':       { en: 'Status',      he: 'סטטוס' },
  'common.created':      { en: 'Created',     he: 'נוצר' },
  'common.active':       { en: 'Active',      he: 'פעיל' },
  'common.inactive':     { en: 'Inactive',    he: 'לא פעיל' },
  'common.weight':       { en: 'Weight',      he: 'משקל' },
  'common.addRow':       { en: 'Add Row',     he: 'הוסף שורה' },
  'common.saving':       { en: 'Saving…',     he: 'שומר…' },
  'common.uploading':    { en: 'Uploading…',  he: 'מעלה…' },
  'common.refresh':      { en: 'Refresh',     he: 'רענן' },
  'common.adding':       { en: 'Adding…',     he: 'מוסיף…' },
  'common.removing':     { en: 'Removing…',   he: 'מסיר…' },
  'common.assigning':    { en: 'Assigning…',  he: 'משייך…' },
  'common.level':        { en: 'Level',       he: 'רמה' },

  // ── Login ─────────────────────────────────────────────────────────────────
  'login.headline1':     { en: 'Recruitment',  he: 'גיוס' },
  'login.headline2':     { en: 'Management',   he: 'וניהול' },
  'login.appSubtitle':   { en: 'Manage evaluation cycles, candidate scoring, team assignments and interviews — all from one place.', he: 'נהל מחזורי הערכה, ניקוד מועמדים, שיבוץ צוותות וראיונות — הכל ממקום אחד.' },
  'login.title':         { en: 'Sign in',      he: 'כניסה' },
  'login.desc':          { en: 'Enter your credentials to access the admin panel.', he: 'הזן את פרטיך לגישה ללוח הניהול.' },
  'login.password':      { en: 'Password',     he: 'סיסמה' },
  'login.email':         { en: 'Email',        he: 'אימייל' },
  'login.signIn':        { en: 'Sign In',      he: 'כניסה' },
  'login.fillAll':       { en: 'Please fill in all fields', he: 'אנא מלא את כל השדות' },
  'login.invalidCreds':  { en: 'Invalid credentials. Please try again.', he: 'פרטי כניסה שגויים. אנא נסה שוב.' },

  // ── Dashboard ─────────────────────────────────────────────────────────────
  'dash.section':        { en: 'Overview',          he: 'סקירה' },
  'dash.greeting':       { en: 'Good to see you',   he: 'שמחים לראותך' },
  'dash.subtitle':       { en: "Here's what's happening with your recruitment cycles.", he: 'הנה מה שקורה עם מחזורי הגיוס שלך.' },
  'dash.activeCycle':    { en: '● Active Cycle',    he: '● מחזור פעיל' },
  'dash.started':        { en: 'Started',           he: 'התחיל' },
  'dash.viewCycle':      { en: 'View Cycle',        he: 'צפה במחזור' },
  'dash.noActiveCycle':  { en: 'No active cycle running', he: 'אין מחזור פעיל כרגע' },
  'dash.manageCycles':   { en: 'Manage Cycles',     he: 'נהל מחזורים' },
  'dash.allCycles':      { en: 'All Cycles',        he: 'כל המחזורים' },
  'dash.manage':         { en: 'Manage',            he: 'נהל' },
  'dash.noCycles':       { en: 'No cycles created yet', he: 'טרם נוצרו מחזורים' },
  'dash.totalUsers':     { en: 'Total Users',       he: 'סה"כ משתמשים' },
  'dash.draftCycles':    { en: 'Draft Cycles',      he: 'טיוטות' },
  'dash.closedCycles':   { en: 'Closed Cycles',     he: 'מחזורים סגורים' },
  'dash.totalCycles':    { en: 'Total Cycles',      he: 'סה"כ מחזורים' },

  // ── Submission tracker (Dashboard widget) ───────────────────────────────
  'dash.submissionTracker':    { en: 'Form Submission Tracker',              he: 'מעקב הגשת טפסים' },
  'dash.submissionTrackerSub': { en: 'Expected vs. actual submissions, by form and submitter', he: 'הגשות צפויות מול בפועל, לפי טופס ומגיש' },
  'dash.exportMissing':        { en: 'Export Missing (.txt)',                he: 'ייצוא חסרים (.txt)' },
  'dash.allSubmitted':         { en: 'All expected submissions are in.',     he: 'כל ההגשות הצפויות התקבלו.' },
  'dash.noTrackedForms':       { en: 'No forms with role-relevant submitters are assigned to this cycle yet.', he: 'טרם שויכו למחזור זה טפסים עם מגישים רלוונטיים.' },
  'dash.submitted':            { en: 'submitted',                            he: 'הוגשו' },
  'dash.missingFrom':          { en: 'Missing from',                         he: 'חסר מ-' },
  'dash.candidatesLabel':      { en: 'candidates',                           he: 'מועמדים' },

  // ── Units ─────────────────────────────────────────────────────────────────
  'units.section':       { en: 'Organization',      he: 'ארגון' },
  'units.currentUnit':   { en: 'Current Unit',      he: 'יחידה נוכחית' },
  'units.unitId':        { en: 'Unit ID',           he: 'מזהה יחידה' },
  'units.userId':        { en: 'User ID',           he: 'מזהה משתמש' },
  'units.noInfo':        { en: 'No unit information available.', he: 'אין מידע על יחידה.' },
  'units.loading':       { en: 'Loading unit information…', he: 'טוען פרטי יחידה…' },

  // ── Users page ────────────────────────────────────────────────────────────
  'users.addUser':       { en: 'Add User',           he: 'הוסף משתמש' },
  'users.editUser':      { en: 'Edit User',          he: 'ערוך משתמש' },
  'users.createUser':    { en: 'Create User',        he: 'צור משתמש' },
  'users.firstName':     { en: 'First Name *',       he: 'שם פרטי *' },
  'users.lastName':      { en: 'Last Name *',        he: 'שם משפחה *' },
  'users.emailReq':      { en: 'Email *',            he: 'אימייל *' },
  'users.passwordReq':   { en: 'Password *',         he: 'סיסמה *' },
  'users.passwordEdit':  { en: 'Password (leave blank to keep current)', he: 'סיסמה (השאר ריק לשמור הנוכחית)' },
  'users.fillRequired':  { en: 'Please fill in all required fields', he: 'אנא מלא את כל השדות הנדרשים' },
  'users.passwordReqMsg':{ en: 'Password is required for new users', he: 'סיסמה נדרשת למשתמשים חדשים' },
  'users.confirmDelete': { en: 'Delete this user?',  he: 'למחוק משתמש זה?' },
  'users.loading':       { en: 'Loading users…',     he: 'טוען משתמשים…' },
  'users.errorLoad':     { en: 'Error loading users', he: 'שגיאה בטעינת משתמשים' },
  'users.col.name':      { en: 'Name',               he: 'שם' },
  'users.col.roles':     { en: 'Roles',              he: 'תפקידים' },
  'users.col.status':    { en: 'Status',             he: 'סטטוס' },
  'users.col.created':   { en: 'Created',            he: 'נוצר' },

  // ── Cycles page ───────────────────────────────────────────────────────────
  'cycles.new':          { en: 'New Cycle',          he: 'מחזור חדש' },
  'cycles.tab.all':      { en: 'All',                he: 'הכל' },
  'cycles.tab.active':   { en: 'Active',             he: 'פעיל' },
  'cycles.tab.draft':    { en: 'Draft',              he: 'טיוטה' },
  'cycles.tab.closed':   { en: 'Closed',             he: 'סגור' },
  'cycles.noCycles':     { en: 'No cycles',          he: 'אין מחזורים' },
  'cycles.createFirst':  { en: 'Create First Cycle', he: 'צור מחזור ראשון' },
  'cycles.closeCycle':   { en: 'Close Cycle',        he: 'סגור מחזור' },
  'cycles.started':      { en: 'Started',            he: 'התחיל' },
  'cycles.ended':        { en: 'Ended',              he: 'הסתיים' },
  'cycles.closeActiveFirst': { en: 'Close the active cycle first', he: 'סגור קודם את המחזור הפעיל' },
  'cycles.loading':      { en: 'Loading cycles…',    he: 'טוען מחזורים…' },
  'cycles.errorLoad':    { en: 'Error loading cycles', he: 'שגיאה בטעינת מחזורים' },
  'cycles.confirmActivate': { en: 'Activate this cycle?', he: 'להפעיל מחזור זה?' },
  'cycles.confirmDelete': { en: 'Delete this cycle?',  he: 'למחוק מחזור זה?' },
  'cycles.confirmClose':  { en: 'Close this cycle? This cannot be undone.', he: 'לסגור מחזור זה? לא ניתן לבטל.' },
  'cycles.cannotActivate':{ en: 'Cannot activate — another cycle is already active. Close it first.', he: 'לא ניתן להפעיל — מחזור אחר פעיל. סגור אותו תחילה.' },

  // ── Wizard (create cycle) ─────────────────────────────────────────────────
  'wizard.title':        { en: 'New Cycle',          he: 'מחזור חדש' },
  'wizard.opt':          { en: 'opt.',               he: 'אופ.' },
  'wizard.step.basics':  { en: 'Basics',             he: 'בסיסי' },
  'wizard.step.schedule':{ en: 'Schedule',           he: 'לוח זמנים' },
  'wizard.step.review':  { en: 'Review',             he: 'סקירה' },
  'wizard.step.forms':   { en: 'Forms',              he: 'טפסים' },
  'wizard.step.stations':{ en: 'Stations',           he: 'תחנות' },
  'wizard.step.candidates':{ en: 'Candidates',       he: 'מועמדים' },
  'wizard.step.team':    { en: 'Team',               he: 'צוות' },
  'wizard.step.interviews':{ en: 'Interviews',       he: 'ראיונות' },
  'wizard.basics.desc':  { en: 'Name this cycle and set its month/year identifier.', he: 'תן שם למחזור וקבע את מזהה החודש/שנה.' },
  'wizard.displayName':  { en: 'Display Name *',     he: 'שם תצוגה *' },
  'wizard.monthYear':    { en: 'Month / Year (MM-YYYY) *', he: 'חודש / שנה (MM-YYYY) *' },
  'wizard.myHint':       { en: 'Digits only — dash auto-added. Multiple cycles per month are allowed.', he: 'ספרות בלבד — מקף מתווסף אוטומטית. מותר מספר מחזורים לחודש.' },
  'wizard.myInvalid':    { en: 'Use MM-YYYY (e.g. 05-2026)', he: 'השתמש ב-MM-YYYY (למשל 05-2026)' },
  'wizard.schedule.desc':{ en: 'Optional start date and initial status.', he: 'תאריך התחלה ומצב ראשוני (אופציונלי).' },
  'wizard.startDate':    { en: 'Start Date (optional)', he: 'תאריך התחלה (אופציונלי)' },
  'wizard.startDateHint':{ en: 'When the cycle officially begins', he: 'מתי המחזור מתחיל רשמית' },
  'wizard.invalidDate':  { en: 'Invalid date',        he: 'תאריך לא תקין' },
  'wizard.futureDate':   { en: 'Must be today or later', he: 'חייב להיות היום או אחריו' },
  'wizard.initialStatus':{ en: 'Initial Status',      he: 'מצב ראשוני' },
  'wizard.draft.title':  { en: 'Draft',               he: 'טיוטה' },
  'wizard.draft.desc':   { en: 'Not visible to mobile users', he: 'לא מוצג למשתמשי מובייל' },
  'wizard.active.title': { en: 'Active',              he: 'פעיל' },
  'wizard.active.desc':  { en: 'Immediately visible to mobile users', he: 'מוצג מיד למשתמשי מובייל' },
  'wizard.activeWarn':   { en: 'Only one active cycle is allowed at a time.', he: 'מותר מחזור פעיל אחד בכל פעם.' },
  'wizard.review.desc':  { en: 'Review before creating. Optional steps follow.', he: 'בדוק לפני יצירה. שלבים אופציונלים יבואו לאחר מכן.' },
  'wizard.displayNameLabel': { en: 'Display Name',    he: 'שם תצוגה' },
  'wizard.monthYearLabel':   { en: 'Month / Year',    he: 'חודש / שנה' },
  'wizard.startDateLabel':   { en: 'Start Date',      he: 'תאריך התחלה' },
  'wizard.initialStatusLabel': { en: 'Initial Status', he: 'מצב ראשוני' },
  'wizard.forms.desc':   { en: 'Select forms and set each form\'s weight in the final score. Combined weights should not exceed 1.0 (= 100 pts).', he: 'בחר טפסים וקבע את משקל כל טופס בציון הסופי. הסכום לא יעלה על 1.0 (= 100 נקודות).' },
  'wizard.noForms':      { en: 'No form templates available. Create templates in the Form Builder first.', he: 'אין תבניות טפסים. צור תבניות בבונה הטפסים.' },
  'wizard.totalWeight':  { en: 'Total weight:',       he: 'משקל כולל:' },
  'wizard.exceedsWeight':{ en: 'Exceeds maximum — reduce weights before continuing.', he: 'חורג מהמקסימום — הפחת משקלים לפני המשך.' },
  'wizard.exceedsWeightErr': { en: 'Combined form weights exceed 1.0. Please adjust before continuing.', he: 'משקל הטפסים המשולב עולה על 1.0. אנא התאם לפני המשך.' },
  'wizard.stations.desc':{ en: 'Select stations from the bank to add to this cycle. You can also manage stations later.', he: 'בחר תחנות מהבנק להוסיף למחזור. ניתן לנהל תחנות גם מאוחר יותר.' },
  'wizard.noStations':   { en: 'No bank stations available. Create stations in the bank first.', he: 'אין תחנות בבנק. צור תחנות בבנק תחילה.' },
  'wizard.candidates.desc': { en: 'Add candidates manually. Leave empty to configure later via CSV upload.', he: 'הוסף מועמדים ידנית. השאר ריק להגדרה מאוחרת דרך CSV.' },
  'wizard.candNum':      { en: 'Candidate #',         he: 'מועמד #' },
  'wizard.teamNum':      { en: 'Team #',              he: 'צוות #' },
  'wizard.team.desc':    { en: 'Assign users to teams with roles. Leave empty to configure later.', he: 'שייך משתמשים לצוותות עם תפקידים. השאר ריק להגדרה מאוחרת.' },
  'wizard.user':         { en: 'User',                he: 'משתמש' },
  'wizard.interviews.desc': { en: 'Assign interviewers to candidates. Leave empty to configure later.', he: 'שייך מראיינים למועמדים. השאר ריק להגדרה מאוחרת.' },
  'wizard.loadingCands': { en: 'Loading candidates…', he: 'טוען מועמדים…' },
  'wizard.noCands':      { en: 'No candidates found in this cycle. Add candidates first (step 4) or do this later.', he: 'לא נמצאו מועמדים במחזור. הוסף מועמדים תחילה (שלב 4) או עשה זאת מאוחר יותר.' },
  'wizard.addInterview': { en: 'Add Interview Assignment', he: 'הוסף שיבוץ ראיון' },
  'wizard.interviewer':  { en: 'Interviewer',         he: 'מראיין' },
  'wizard.candidates.label': { en: 'Candidates',      he: 'מועמדים' },
  'wizard.creating':     { en: 'Creating…',           he: 'יוצר…' },
  'wizard.createCycle':  { en: 'Create Cycle',        he: 'צור מחזור' },
  'wizard.editCycle':    { en: 'Edit Cycle',          he: 'ערוך מחזור' },
  'wizard.alreadyExists':{ en: 'Already exists',      he: 'כבר קיים' },
  'wizard.formatHint':   { en: 'Format: MM-YYYY',     he: 'פורמט: MM-YYYY' },
  'wizard.allRowsValid': { en: 'All rows need valid positive integers', he: 'כל השורות צריכות מספרים שלמים חיוביים תקינים' },
  'wizard.dupCands':     { en: 'Duplicate candidate numbers found', he: 'נמצאו מספרי מועמדים כפולים' },
  'wizard.allTeamRowsValid': { en: 'All team rows must have user, team number, and role', he: 'כל שורות הצוות חייבות לכלול משתמש, מספר צוות ותפקיד' },
  'wizard.oneAssignment':{ en: 'A user can only have one team assignment per cycle', he: 'למשתמש יכולה להיות שיבוץ צוות אחד בלבד למחזור' },
  'wizard.addForms':     { en: 'Add Forms',             he: 'הוסף טפסים' },
  'wizard.addStations':  { en: 'Add Stations',          he: 'הוסף תחנות' },
  'wizard.uploadCandidates': { en: 'Upload Candidates', he: 'העלה מועמדים' },
  'wizard.assignTeam':   { en: 'Assign Team',           he: 'שייך צוות' },
  'wizard.formsSelected':{ en: 'forms selected',        he: 'טפסים נבחרו' },
  'wizard.stationsSelected': { en: 'stations selected', he: 'תחנות נבחרו' },
  'wizard.candsReady':   { en: 'candidates ready to upload', he: 'מועמדים מוכנים להעלאה' },
  'wizard.selectUser':   { en: 'Select user',           he: 'בחר משתמש' },

  // ── Cycle Detail ──────────────────────────────────────────────────────────
  'cd.backTooltip':      { en: 'Back to Cycles',     he: 'חזרה למחזורים' },
  'cd.started':          { en: 'Started',            he: 'התחיל' },
  'cd.ended':            { en: 'Ended',              he: 'הסתיים' },
  'cd.created':          { en: 'Created',            he: 'נוצר' },
  'cd.agg.total':        { en: 'Total',              he: 'סה"כ' },
  'cd.agg.active':       { en: 'Active',             he: 'פעיל' },
  'cd.agg.inactive':     { en: 'Inactive',           he: 'לא פעיל' },
  'cd.agg.completed':    { en: 'Completed',          he: 'הושלם' },
  'cd.agg.incompleted':  { en: 'Incompleted',        he: 'לא הושלם' },
  'cd.agg.unknown':      { en: 'Unknown',            he: 'לא ידוע' },
  'cd.tab.candidates':   { en: 'Candidates',         he: 'מועמדים' },
  'cd.tab.team':         { en: 'Team',               he: 'צוות' },
  'cd.tab.interviews':   { en: 'Interviews',         he: 'ראיונות' },
  'cd.tab.forms':        { en: 'Forms',              he: 'טפסים' },
  'cd.tab.stations':     { en: 'Stations',           he: 'תחנות' },
  'cd.tab.statements':   { en: 'Statements',         he: 'הצהרות' },
  'cd.tab.registration': { en: 'Registration',        he: 'הרשמה' },
  'reg.title':           { en: 'Candidate self-registration', he: 'הרשמה עצמית של מועמדים' },
  'reg.status.open':     { en: 'Registration is open',   he: 'ההרשמה פתוחה' },
  'reg.status.closed':   { en: 'Registration is closed', he: 'ההרשמה סגורה' },
  'reg.registered':      { en: 'Registered',             he: 'נרשמו' },
  'reg.cap':             { en: 'Cap (optional)',         he: 'מכסה (אופציונלי)' },
  'reg.closesAt':        { en: 'Closes at (optional)',   he: 'נסגר ב- (אופציונלי)' },
  'reg.open':            { en: 'Open registration',      he: 'פתח הרשמה' },
  'reg.close':           { en: 'Close registration',     he: 'סגור הרשמה' },
  'reg.cycleClosed':     { en: 'This cycle is closed; registration cannot be opened.', he: 'המחזור סגור; לא ניתן לפתוח הרשמה.' },
  'reg.final':           { en: 'Registration is final. Registered candidates cannot be removed from here.', he: 'ההרשמה סופית. לא ניתן להסיר מועמדים שנרשמו מכאן.' },
  'reg.scanToRegister':  { en: 'Scan to register',       he: 'סרקו כדי להירשם' },
  'reg.noUrl':           { en: 'REACT_APP_REGISTRATION_URL is not configured, so the QR code and link cannot be shown.', he: 'REACT_APP_REGISTRATION_URL לא מוגדר, ולכן לא ניתן להציג קוד QR וקישור.' },
  'reg.closesOn':        { en: 'Closes at',              he: 'נסגר ב-' },
  'reg.copyLink':        { en: 'Copy link',              he: 'העתק קישור' },
  'reg.copyQr':          { en: 'Copy QR image',          he: 'העתק תמונת QR' },
  'reg.copied':          { en: 'Copied',                 he: 'הועתק' },
  'reg.openPage':        { en: 'Open registration page', he: 'פתח את דף ההרשמה' },
  'cd.loading':          { en: 'Loading cycle…',     he: 'טוען מחזור…' },
  'cd.errorLoad':        { en: 'Error loading cycle', he: 'שגיאה בטעינת המחזור' },
  'cd.notFound':         { en: 'Cycle not found',    he: 'המחזור לא נמצא' },

  // ── Form types ────────────────────────────────────────────────────────────
  'formType.generic':    { en: 'Generic',            he: 'כללי' },
  'formType.socio':      { en: 'Socio',              he: 'סוציו' },
  'formType.teamleadRank': { en: 'Team Lead Rank',   he: 'דירוג ראש צוות' },
  'formType.interview':  { en: 'Interview',          he: 'ראיון' },

  // ── Forms tab (CycleDetail) ───────────────────────────────────────────────
  'form.addFromBank':    { en: 'Add from Bank',      he: 'הוסף מהבנק' },
  'form.noneConfigured': { en: 'No forms configured for this cycle', he: 'לא הוגדרו טפסים למחזור זה' },
  'form.combinedWeight': { en: 'Combined weight:',   he: 'משקל כולל:' },
  'form.exceedsMax':     { en: 'exceeds maximum, scores may exceed 100 pts', he: 'חורג מהמקסימום, הציונים עשויים לעלות על 100 נקודות' },
  'form.weightInFinal':  { en: 'Weight in final score', he: 'משקל בציון הסופי' },
  'form.mandatory':      { en: 'Mandatory for closure', he: 'חובה לסגירה' },
  'form.removeFromCycle':{ en: 'Remove from cycle',  he: 'הסר מהמחזור' },
  'form.inactive':       { en: 'Inactive',           he: 'לא פעיל' },
  'form.loadingForms':   { en: 'Loading forms…',     he: 'טוען טפסים…' },
  'form.errorLoad':      { en: 'Error loading forms', he: 'שגיאה בטעינת טפסים' },
  'form.addFromBankTitle': { en: 'Add Forms from Bank', he: 'הוסף טפסים מהבנק' },

  // ── Station types & tab ───────────────────────────────────────────────────
  'stationType.ordered':      { en: 'Ordered',      he: 'מסודר' },
  'stationType.accumulative': { en: 'Accumulative', he: 'מצטבר' },
  'stationType.individual':   { en: 'Individual',   he: 'אישי' },
  'station.addFromBank':      { en: 'Add from Bank', he: 'הוסף מהבנק' },
  'station.noneConfigured':   { en: 'No stations configured for this cycle', he: 'לא הוגדרו תחנות למחזור זה' },
  'station.legacyId':         { en: 'Legacy ID',    he: 'מזהה ישן' },
  'station.removeFromCycle':  { en: 'Remove from cycle', he: 'הסר מהמחזור' },
  'station.loadingStations':  { en: 'Loading stations…', he: 'טוען תחנות…' },
  'station.errorLoad':        { en: 'Error loading stations', he: 'שגיאה בטעינת תחנות' },
  'station.addFromBankTitle': { en: 'Add Stations from Bank', he: 'הוסף תחנות מהבנק' },

  // ── Bank modal (shared) ───────────────────────────────────────────────────
  'bank.noItems':        { en: 'No items available in the bank', he: 'אין פריטים זמינים בבנק' },
  'bank.addSelected':    { en: 'Add Selected',      he: 'הוסף נבחרים' },

  // ── Candidates table (CycleDetail) ────────────────────────────────────────
  'cands.loading':       { en: 'Loading candidates…', he: 'טוען מועמדים…' },
  'cands.errorLoad':     { en: 'Error loading candidates', he: 'שגיאה בטעינת מועמדים' },
  'cands.col.num':       { en: 'Candidate #',        he: 'מועמד #' },
  'cands.col.team':      { en: 'Team #',             he: 'צוות #' },
  'cands.col.status':    { en: 'Status',             he: 'סטטוס' },
  'cands.col.cycleScore':{ en: 'Cycle Score',        he: 'ציון מחזור' },
  'cands.col.socioScore':{ en: 'Socio Score',        he: 'ציון סוציו' },
  'cands.col.assessScore':{ en: 'Assessment Score',  he: 'ציון גיבוש' },
  'cands.col.intScore':  { en: 'Interview Score',    he: 'ציון ראיון' },
  'cands.col.tlRank':    { en: 'Team Lead Rank',     he: 'דירוג ראש צוות' },
  'cands.col.matam':     { en: 'Personal Matam',     he: 'מתא"ם אישי' },
  'cands.col.redFlag':   { en: 'Red Flag',           he: 'דגל אדום' },
  'cands.col.inactReason':{ en: 'Inactivation Reason', he: 'סיבת ביטול' },
  'cands.col.reasonDetails': { en: 'Reason Details', he: 'פרטי הסיבה' },
  'cands.col.actions':   { en: 'Actions',            he: 'פעולות' },
  'cands.updateStatus':  { en: 'Update Status',      he: 'עדכן סטטוס' },
  'cands.statusLabel':   { en: 'Status',             he: 'סטטוס' },
  'cands.inactReasonLabel': { en: 'Inactivation Reason', he: 'סיבת ביטול' },
  'cands.additionalDetails': { en: 'Additional Details', he: 'פרטים נוספים' },
  'cands.matamLabel':    { en: 'Personal Matam (1–6)', he: 'מתא"ם אישי (1–6)' },
  'cands.uploadWarning': { en: 'Replaces ALL existing candidates and their scores — irreversible', he: 'מחליף את כל המועמדים הקיימים ואת ציוניהם — בלתי הפיך' },
  'cands.inactReasonRequired': { en: 'Inactivation reason is required when setting status to inactive', he: 'נדרשת סיבת ביטול בעת קביעת סטטוס ללא פעיל' },
  'cands.selectCsvFile': { en: 'Please select a CSV file', he: 'אנא בחר קובץ CSV' },
  'cands.confirmUploadTitle': { en: 'Destructive Operation — Confirm CSV Upload', he: 'פעולה הרסנית — אשר העלאת CSV' },
  'cands.confirmUploadBody':  { en: 'This will permanently delete all existing candidates for this cycle — including any scores, status history, and team assignments — and recreate them from the CSV file. This action cannot be undone.', he: 'פעולה זו תמחק לצמיתות את כל המועמדים הקיימים במחזור זה — כולל ציונים, היסטוריית סטטוס ושיבוצי צוות — ותיצור אותם מחדש מקובץ ה-CSV. לא ניתן לבטל פעולה זו.' },
  'cands.confirmUploadFile':  { en: 'File', he: 'קובץ' },
  'cands.confirmUploadConfirm': { en: 'Yes, Replace All Candidates', he: 'כן, החלף את כל המועמדים' },

  // ── Team assignments table ────────────────────────────────────────────────
  'team.col.email':      { en: 'Email',              he: 'אימייל' },
  'team.col.name':       { en: 'Name',               he: 'שם' },
  'team.col.role':       { en: 'Role',               he: 'תפקיד' },
  'team.col.teamNum':    { en: 'Team #',             he: 'צוות #' },
  'team.loading':        { en: 'Loading team assignments…', he: 'טוען שיבוצי צוות…' },
  'team.errorLoad':      { en: 'Error loading team assignments', he: 'שגיאה בטעינת שיבוצי צוות' },
  'team.csvHint':        { en: 'CSV columns: email,role,team', he: 'עמודות CSV: email,role,team' },
  'team.uploadCsv':      { en: 'Upload CSV',         he: 'העלה CSV' },
  'team.userLabel':      { en: 'User',               he: 'משתמש' },
  'team.teamNumber':     { en: 'Team Number',        he: 'מספר צוות' },
  'team.selectCsv':      { en: 'Please select a CSV file', he: 'אנא בחר קובץ CSV' },
  'team.allFieldsRequired': { en: 'All fields are required', he: 'כל השדות נדרשים' },
  'team.positiveInt':    { en: 'Team number must be a positive integer', he: 'מספר הצוות חייב להיות מספר שלם חיובי' },
  'team.addedSuccess':   { en: 'Assignment added successfully', he: 'השיבוץ נוסף בהצלחה' },
  'team.addAssignment':  { en: 'Add Assignment', he: 'הוסף שיבוץ' },

  // ── Interviewers table ────────────────────────────────────────────────────
  'intv.col.email':      { en: 'Email',              he: 'אימייל' },
  'intv.col.name':       { en: 'Name',               he: 'שם' },
  'intv.col.role':       { en: 'Role',               he: 'תפקיד' },
  'intv.col.candidates': { en: 'Assigned Candidates', he: 'מועמדים משובצים' },
  'intv.loading':        { en: 'Loading interviewers…', he: 'טוען מראיינים…' },
  'intv.errorLoad':      { en: 'Error loading interviewers', he: 'שגיאה בטעינת מראיינים' },
  'intv.csvHint':        { en: 'CSV columns: email,candidate_team_number,candidate_number', he: 'עמודות CSV: email,candidate_team_number,candidate_number' },
  'intv.uploadCsv':      { en: 'Upload CSV',         he: 'העלה CSV' },
  'intv.interviewer':    { en: 'Interviewer',        he: 'מראיין' },
  'intv.candidates':     { en: 'Candidates',         he: 'מועמדים' },
  'intv.removeAll':      { en: 'Remove all assignments for this interviewer', he: 'הסר את כל שיבוצי המראיין הזה' },
  'intv.selectCsv':      { en: 'Please select a CSV file', he: 'אנא בחר קובץ CSV' },
  'intv.selectBoth':     { en: 'Select an interviewer and at least one candidate', he: 'בחר מראיין ומועמד אחד לפחות' },
  'intv.addedSuccess':   { en: 'Interview assignment added successfully', he: 'שיבוץ הראיון נוסף בהצלחה' },
  'intv.removedSuccess': { en: 'Interviewer assignments removed', he: 'שיבוצי המראיין הוסרו' },
  'intv.remove':         { en: 'Remove',             he: 'הסר' },
  'intv.removing':       { en: 'Removing…',          he: 'מסיר…' },
  'intv.addAssignment':  { en: 'Add Assignment',     he: 'הוסף שיבוץ' },
  'intv.addTitle':       { en: 'Add Interview Assignment', he: 'הוסף שיבוץ ראיון' },
  'intv.removeTitle':    { en: 'Remove Interviewer', he: 'הסר מראיין' },
  'intv.removeBody':     { en: 'Remove all interview assignments for this interviewer? This cannot be undone.', he: 'להסיר את כל שיבוצי הראיון של מראיין זה? לא ניתן לבטל.' },
  'intv.noneAssigned':   { en: 'No interviewers assigned yet', he: 'לא שובצו מראיינים עדיין' },
  'intv.noAssignments':  { en: 'No assignments', he: 'אין שיבוצים' },
  'intv.assignments':    { en: 'assignments', he: 'שיבוצים' },

  // ── Parameters bank ───────────────────────────────────────────────────────
  'param.tab':           { en: 'Parameters Bank',  he: 'בנק פרמטרים' },
  'param.bankHint':      { en: 'Shared by every station, form and statement in your unit. A rename shows everywhere except cycles that already started.', he: 'משותף לכל התחנות, הטפסים וההצהרות ביחידה. שינוי שם מופיע בכל מקום, חוץ ממחזורים שכבר התחילו.' },
  'param.add':           { en: 'Add parameter',    he: 'הוסף פרמטר' },
  'param.addTitle':      { en: 'New parameter',    he: 'פרמטר חדש' },
  'param.name':          { en: 'Name',             he: 'שם' },
  'param.description':   { en: 'Description',      he: 'תיאור' },
  'param.scale':         { en: 'Scale',            he: 'סולם' },
  'param.usedIn':        { en: 'Used in',          he: 'בשימוש ב' },
  'param.station':       { en: 'station',          he: 'תחנה' },
  'param.stations':      { en: 'stations',         he: 'תחנות' },
  'param.form':          { en: 'form',             he: 'טופס' },
  'param.forms':         { en: 'forms',            he: 'טפסים' },
  'param.statement':     { en: 'statement',        he: 'הצהרה' },
  'param.statements':    { en: 'statements',       he: 'הצהרות' },
  'param.empty':         { en: 'No parameters yet', he: 'אין פרמטרים עדיין' },
  'param.nameRequired':  { en: 'Name is required', he: 'שם הוא שדה חובה' },
  'param.create':        { en: 'Create',           he: 'צור' },
  'param.save':          { en: 'Save',             he: 'שמור' },
  'param.cancel':        { en: 'Cancel',           he: 'ביטול' },
  'param.edit':          { en: 'Edit',             he: 'עריכה' },
  'param.saveError':     { en: 'Failed to save parameter', he: 'שמירת הפרמטר נכשלה' },
  'param.loadError':     { en: 'Failed to load parameters', he: 'טעינת הפרמטרים נכשלה' },
  'param.pick':          { en: 'Parameter (from bank)', he: 'פרמטר (מהבנק)' },
  'param.pickMany':      { en: 'Pick from bank',   he: 'בחר מהבנק' },
  'param.newInBank':     { en: '+ New parameter in bank', he: '+ פרמטר חדש בבנק' },
  'param.notLinked':     { en: 'Not linked — pick from bank', he: 'לא מקושר — בחר מהבנק' },
  'param.notLinkedShort': { en: 'Not linked',      he: 'לא מקושר' },
  'param.unlinkedScale': { en: 'Scale parameter #{n} ({name}) is not linked — pick it from the bank', he: 'פרמטר סולם #{n} ({name}) אינו מקושר — בחר אותו מהבנק' },
  'param.unlinkedGradeBox': { en: 'Grade field #{n} ({name}) is not linked — pick it from the bank', he: 'שדה ציון #{n} ({name}) אינו מקושר — בחר אותו מהבנק' },
  'param.unavailable':   { en: 'Unavailable parameter', he: 'פרמטר לא זמין' },
  'param.unnamed':       { en: 'unnamed',          he: 'ללא שם' },
  'param.quickAdd':      { en: "Quick add from this station's parameters:", he: 'הוספה מהירה מהפרמטרים של התחנה:' },

  // ── Shared legacy stations ────────────────────────────────────────────────
  'station.shared':       { en: 'Shared',          he: 'משותפת' },
  'station.view':         { en: 'View',            he: 'צפייה' },
  'station.sharedNotice': { en: 'This is a shared legacy station: read-only. Clone it to your bank to edit it.', he: 'זו תחנה משותפת מגרסה קודמת: לקריאה בלבד. שכפל אותה לבנק שלך כדי לערוך.' },
  'station.cloneToBank':  { en: 'Clone to my bank', he: 'שכפל לבנק שלי' },
  'station.cloning':      { en: 'Cloning…',        he: 'משכפל…' },
  'station.cloned':       { en: 'Cloned to your bank — you are now editing the copy.', he: 'שוכפלה לבנק שלך — כעת אתה עורך את העותק.' },
  'station.cloneError':   { en: 'Clone failed.',   he: 'השכפול נכשל.' },

  // ── Cycle weights (P1) ────────────────────────────────────────────────────
  'weights.title':      { en: 'Weights for this cycle', he: 'משקלים למחזור' },
  'weights.desc':       { en: "Each graded parameter's share of the form or station score. Empty = all equal, as today. Locked once the cycle is active.", he: 'חלקו של כל פרמטר מסומן בציון הטופס או התחנה. ריק = כולם שווים, כמו היום. ננעל כשהמחזור פעיל.' },
  'weights.parameter':  { en: 'parameter', he: 'פרמטר' },
  'weights.weight':     { en: 'Weight', he: 'משקל' },
  'weights.total':      { en: 'Total', he: 'סה״כ' },
  'weights.ok':         { en: '100% ✓', he: '100% ✓' },
  'weights.bad':        { en: '{n}% — must be exactly 100%', he: '{n}% — חייב להיות בדיוק 100%' },
  'weights.incomplete': { en: 'Fill every weight, or clear them all', he: 'מלא את כל המשקלים, או נקה את כולם' },
  'weights.empty':      { en: 'Empty — all equal', he: 'ריק — כולם שווים' },
  'weights.locked':     { en: 'Locked — the cycle is active', he: 'נעול — המחזור פעיל' },
  'weights.save':       { en: 'Save weights', he: 'שמור משקלים' },
  'weights.saved':      { en: 'Weights saved', he: 'המשקלים נשמרו' },
  'weights.none':       { en: 'No summary forms or graded stations in this cycle', he: 'אין במחזור זה טפסי סיכום או תחנות עם ציונים' },
  'score.weighted':     { en: 'Weighted', he: 'משוקלל' },
  // ── Statements (P2) ───────────────────────────────────────────────────────
  'stmt.cycleTitle':     { en: 'Statements for this cycle', he: 'הצהרות למחזור זה' },
  'stmt.cycleHint':      { en: 'Chosen from the statement bank — this cycle keeps its own copy. Assessors tap these in the quick-note pop-up; they never change a score.', he: 'נבחרות מבנק ההצהרות — המחזור שומר עותק משלו. המעריכים בוחרים אותן בחלון הרשומה המהירה; הן אינן משנות ציון.' },
  'stmt.chooseFromBank': { en: 'Choose from bank', he: 'בחר מהבנק' },
  'stmt.editBank':       { en: 'Edit bank',        he: 'ערוך בנק' },
  'stmt.none':           { en: 'No statements chosen for this cycle', he: 'לא נבחרו הצהרות למחזור זה' },
  'stmt.locked':         { en: "Fixed — the cycle has started, so its statements can't change.", he: 'נעול — המחזור התחיל ולכן אי אפשר לשנות את ההצהרות.' },
  'stmt.remove':         { en: 'Remove from cycle', he: 'הסר מהמחזור' },
  'stmt.bankTitle':      { en: 'Statement bank',   he: 'בנק הצהרות' },
  'stmt.bankHint':       { en: "Shared by all your unit's cycles. Each cycle keeps a copy of the statements it chose, so edits here don't change existing cycles. Only admins see the parameter link.", he: 'משותף לכל המחזורים ביחידה. כל מחזור שומר עותק של ההצהרות שבחר, כך ששינויים כאן לא משנים מחזורים קיימים. רק מנהלים רואים את הקישור לפרמטר.' },
  'stmt.text':           { en: 'Statement',        he: 'הצהרה' },
  'stmt.tone':           { en: 'Tone',             he: 'אופי' },
  'stmt.parameter':      { en: 'Parameter',        he: 'פרמטר' },
  'stmt.noParameter':    { en: 'No parameter',     he: 'ללא פרמטר' },
  'stmt.add':            { en: 'Add statement',    he: 'הוסף הצהרה' },
  'stmt.bankEmpty':      { en: 'No statements yet — add the first one above', he: 'אין הצהרות עדיין — הוסף את הראשונה למעלה' },
  'tone.positive':       { en: 'Positive',         he: 'חיובית' },
  'tone.negative':       { en: 'Negative',         he: 'שלילית' },
  'tone.neutral':        { en: 'Neutral',          he: 'ניטרלית' },

  // ── Station guidance (P2) ─────────────────────────────────────────────────
  'guide.title':         { en: 'Guidance for assessors', he: 'הנחיות למעריכים' },
  'guide.purpose':       { en: 'Purpose',          he: 'מטרה' },
  'guide.gear':          { en: 'Gear',             he: 'ציוד' },
  'guide.gearItem':      { en: 'Item',             he: 'פריט' },
  'guide.quantity':      { en: 'Qty',              he: 'כמות' },
  'guide.addItem':       { en: 'Add item',         he: 'הוסף פריט' },
  'guide.timeLimit':     { en: 'Time limit (min)', he: 'זמן (דק׳)' },
  'guide.space':         { en: 'Space',            he: 'מרחב' },
  'guide.minAssessors':  { en: 'Min. assessors',   he: 'מינימום מעריכים' },
  'guide.safety':        { en: 'Safety notes',     he: 'הערות בטיחות' },
  'guide.combinedGear':  { en: 'Gear for all stations', he: 'ציוד לכל התחנות' },
  'guide.noGear':        { en: 'No gear listed for this cycle’s stations', he: 'לא הוגדר ציוד לתחנות המחזור' },

  // ── Station builder ─────────────────────────────────────────
  'sb.color': { en: 'Color (optional)', he: 'צבע (לא חובה)' },
  'sb.counter': { en: 'Counter', he: 'מונה' },
  'sb.nameHe': { en: 'Name (Hebrew)', he: 'שם (בעברית)' },
  'sb.unit': { en: 'Unit', he: 'יחידה' },
  'sb.egSpoke': { en: 'e.g. דיבר', he: 'לדוגמה: דיבר' },
  'sb.egTimes': { en: 'e.g. פעמים', he: 'לדוגמה: פעמים' },
  'sb.scaleParam': { en: 'Scale Parameter', he: 'פרמטר בסולם' },
  'sb.textParam': { en: 'Text Parameter', he: 'פרמטר טקסט' },
  'sb.egConfidence': { en: 'e.g. בטחון עצמי', he: 'לדוגמה: בטחון עצמי' },
  'sb.valueType': { en: 'Value Type', he: 'סוג ערך' },
  'sb.scaleGrade': { en: 'Scale (grade)', he: 'סולם (ציון)' },
  'sb.text': { en: 'Text', he: 'טקסט' },
  'sb.maxGrade': { en: 'Max Grade', he: 'ציון מקסימלי' },
  'sb.required': { en: 'Required', he: 'חובה' },
  'sb.invalidJson': { en: 'Invalid JSON file', he: 'קובץ JSON לא תקין' },
  'sb.saved': { en: 'Station saved to bank successfully.', he: 'התחנה נשמרה בבנק.' },
  'sb.saveFailed': { en: 'Save failed.', he: 'השמירה נכשלה.' },
  'sb.deleteFailed': { en: 'Delete failed.', he: 'המחיקה נכשלה.' },
  'sb.nameRequired': { en: 'Station name is required before saving.', he: 'יש להזין שם תחנה לפני השמירה.' },
  'stationType.accumulative_2': { en: 'Accumulative V2', he: 'מצטבר V2' },
  'sb.title': { en: 'Station Builder', he: 'בונה תחנות' },
  'sb.editingBank': { en: 'Editing bank station', he: 'עריכת תחנה מהבנק' },
  'sb.newStation': { en: 'New Station', he: 'תחנה חדשה' },
  'sb.loadJson': { en: 'Load JSON', he: 'טעינת JSON' },
  'sb.download': { en: 'Download', he: 'הורדה' },
  'sb.copied': { en: 'Copied!', he: 'הועתק!' },
  'sb.copyJson': { en: 'Copy JSON', he: 'העתקת JSON' },
  'sb.updateInBank': { en: 'Update in Bank', he: 'עדכון בבנק' },
  'sb.saveToBank': { en: 'Save to Bank', he: 'שמירה לבנק' },
  'sb.tab.builder': { en: 'Builder', he: 'בונה' },
  'sb.tab.bank': { en: 'Stations Bank', he: 'בנק תחנות' },
  'sb.quickStart': { en: 'Quick Start Templates', he: 'תבניות להתחלה מהירה' },
  'sb.tpl.ordered': { en: '🏃 Ordered (Ranking)', he: '🏃 מסודר (דירוג)' },
  'sb.tpl.accumulative': { en: '📊 Accumulative (Counters)', he: '📊 מצטבר (מונים)' },
  'sb.tpl.accumulative_2': { en: '🧮 Accumulative V2 (Tap Grid)', he: '🧮 מצטבר V2 (רשת הקשה)' },
  'sb.tpl.individual': { en: '👤 Individual (Rubric)', he: '👤 אישי (מחוון)' },
  'sb.definition': { en: 'Station Definition', he: 'הגדרת תחנה' },
  'sb.level': { en: 'Level (sort order)', he: 'רמה (סדר מיון)' },
  'sb.levelHint': { en: '0 is a valid level', he: '0 היא רמה תקינה' },
  'sb.name': { en: 'Name (display name)', he: 'שם (לתצוגה)' },
  'sb.egSprints': { en: 'e.g. ספרינטים', he: 'לדוגמה: ספרינטים' },
  'sb.description': { en: 'Description (optional)', he: 'תיאור (לא חובה)' },
  'sb.descriptionHint': { en: 'Shown in the start modal', he: 'מוצג בחלון התחלת התחנה' },
  'sb.type': { en: 'Type:', he: 'סוג:' },
  'sb.freeScore': { en: 'Include assessor free-score popup', he: 'הצגת חלון ציון דעת מעריך' },
  'sb.freeScoreHint': { en: "When closing this station, mobile prompts the evaluator for a 1–7 gut-feel score per candidate. Doesn't affect the station's own score.", he: 'בסגירת התחנה, האפליקציה מבקשת מהמעריך ציון תחושה 1–7 לכל מועמד. לא משפיע על ציון התחנה.' },
  'sb.evalInfo': { en: 'Evaluator Info', he: 'מידע למעריך' },
  'sb.evalInfoHint': { en: "Shown in the mobile app's start-station panel, before the evaluator begins.", he: 'מוצג באפליקציה בחלון התחלת התחנה, לפני שהמעריך מתחיל.' },
  'sb.purpose': { en: 'Purpose (optional)', he: 'מטרה (לא חובה)' },
  'sb.egPurpose': { en: 'e.g. לבחון יוזמה ועבודת צוות תחת לחץ זמן', he: 'לדוגמה: לבחון יוזמה ועבודת צוות תחת לחץ זמן' },
  'sb.egSpace': { en: 'e.g. מגרש פתוח', he: 'לדוגמה: מגרש פתוח' },
  'sb.safety': { en: 'Safety notes (optional)', he: 'הערות בטיחות (לא חובה)' },
  'sb.egSafety': { en: 'e.g. לוודא מים זמינים, אין ריצה על משטח רטוב', he: 'לדוגמה: לוודא מים זמינים, אין ריצה על משטח רטוב' },
  'sb.safetyHint': { en: 'Shown in amber on mobile', he: 'מוצג בכתום באפליקציה' },
  'sb.notes': { en: 'Notes for evaluator (optional)', he: 'הערות למעריך (לא חובה)' },
  'sb.egNotes': { en: 'e.g. וודאו שכל מועמד עונה על כל הפרמטרים', he: 'לדוגמה: וודאו שכל מועמד עונה על כל הפרמטרים' },
  'sb.limitation': { en: 'Limitation (optional)', he: 'מגבלה (לא חובה)' },
  'sb.egLimitation': { en: 'e.g. מקסימום 8 מועמדים בסבב', he: 'לדוגמה: מקסימום 8 מועמדים בסבב' },
  'sb.limitationHint': { en: 'Shown in an amber warning box on mobile — use for constraints or caveats', he: 'מוצג באפליקציה בתיבת אזהרה כתומה — לאילוצים או הסתייגויות' },
  'sb.highlighted': { en: 'Highlighted parameters', he: 'פרמטרים מודגשים' },
  'sb.quickAdd': { en: "Quick add from this station's parameters:", he: 'הוספה מהירה מפרמטרי התחנה:' },
  'sb.orderedConfig': { en: 'Ordered Config', he: 'הגדרות תחנה מסודרת' },
  'sb.acc2Config': { en: 'Accumulative V2 Config', he: 'הגדרות מצטבר V2' },
  'sb.accConfig': { en: 'Accumulative Config', he: 'הגדרות מצטבר' },
  'sb.multiRound': { en: 'Multi-round', he: 'רב-סבבי' },
  'sb.roundCount': { en: 'Round Count (blank = unbounded)', he: 'מספר סבבים (ריק = ללא הגבלה)' },
  'sb.textAnnotations': { en: 'Text annotations', he: 'הערות טקסט' },
  'sb.addCounter': { en: 'Add Counter', he: 'הוסף מונה' },
  'sb.noCounters': { en: 'No counters yet — add at least one', he: 'אין מונים עדיין — הוסף לפחות אחד' },
  'sb.scale': { en: 'Scale', he: 'סולם' },
  'sb.noParams': { en: 'No parameters yet — add Scale or Text above', he: 'אין פרמטרים עדיין — הוסף סולם או טקסט למעלה' },
  'sb.jsonOutput': { en: 'JSON Output', he: 'פלט JSON' },
  'sb.loadingBank': { en: 'Loading bank stations…', he: 'טוען תחנות מהבנק…' },
  'sb.noBank': { en: 'No bank stations yet', he: 'אין עדיין תחנות בבנק' },
  'sb.noBankHint': { en: 'Switch to the Builder tab and click "Save to Bank" to add one.', he: 'עבור ללשונית "בונה" ולחץ "שמירה לבנק" כדי להוסיף תחנה.' },
  'sb.evalInfoChip': { en: 'Eval info', he: 'מידע למעריך' },
  'sb.noFreeScore': { en: 'No free-score popup', he: 'ללא ציון דעת מעריך' },
  'sb.editing': { en: 'Editing', he: 'בעריכה' },
  'sb.deleteTitle': { en: 'Delete Bank Station', he: 'מחיקת תחנה מהבנק' },
  'sb.orderedNone': { en: 'No additional configuration required.', he: 'אין צורך בהגדרות נוספות.' },
  'sb.orderedHint': { en: 'Assessors will drag and drop candidates into rank order. Supports unlimited rounds — each round is saved independently.', he: 'המעריכים גוררים את המועמדים לסדר דירוג. אין הגבלה על מספר הסבבים — כל סבב נשמר בנפרד.' },
  'sb.acc2Hint': { en: 'Tap-to-count grid layout: 1 counter renders as a single full-width panel, 2 counters as side-by-side panels. Not validated against 3+ counters — undefined layout if configured that way. Text annotations have no effect (no annotation UI exists for this station type yet).', he: 'רשת ספירה בהקשה: מונה אחד מוצג כלוח ברוחב מלא, שני מונים כלוחות זה לצד זה. לא נבדק עם 3 מונים ומעלה — הפריסה במקרה כזה לא מוגדרת. להערות טקסט אין השפעה (עדיין אין ממשק הערות לסוג תחנה זה).' },
  'sb.counters': { en: 'Counters', he: 'מונים' },
  'sb.parameters': { en: 'Parameters', he: 'פרמטרים' },
  'sb.lines': { en: 'lines', he: 'שורות' },
  'sb.deleteBodyBefore': { en: 'This permanently deletes', he: 'פעולה זו מוחקת לצמיתות את' },
  'sb.deleteBodyAfter': { en: 'from the bank. Existing cycle clones are not affected.', he: 'מהבנק. עותקים קיימים במחזורים לא יושפעו.' },

  // ── Roles ─────────────────────────────────────────────────────────────────
  'role.admin':          { en: 'Admin',            he: 'מנהל' },
  'role.teamlead':       { en: 'Team lead',        he: 'ראש צוות' },
  'role.assessor':       { en: 'Assessor',         he: 'מעריך' },
  'role.socio':          { en: 'Socio',            he: 'סוציו' },
  'role.interviewer':    { en: 'Interviewer',      he: 'מראיין' },
  'role.viewer':         { en: 'Viewer',           he: 'צופה' },
  'role.trainee':        { en: 'Trainee',          he: 'חניך' },

  // ── Form builder: field types ─────────────────────────────────────────────
  'fb.field.gradebox':     { en: 'Grade Box',   he: 'תיבת ציון' },
  'fb.field.textboxblock': { en: 'Text Box',    he: 'תיבת טקסט' },
  'fb.field.flagblock':    { en: 'Flag Block',  he: 'דגל' },
  'fb.field.selectbox':    { en: 'Select List', he: 'רשימת בחירה' },

  // ── Form builder ─────────────────────────────────────────
  'fb.noFields': { en: 'No fields yet — add Grade Box, Text Box, or Flag above', he: 'אין שדות עדיין — הוסף תיבת ציון, תיבת טקסט או דגל למעלה' },
  'fb.color': { en: 'Color', he: 'צבע' },
  'fb.title': { en: 'Title', he: 'כותרת' },
  'fb.textInput': { en: 'Text input', he: 'קלט טקסט' },
  'fb.textPlaceholder': { en: 'Text Placeholder', he: 'טקסט מציין מקום' },
  'fb.placeholder': { en: 'Placeholder', he: 'טקסט מציין מקום' },
  'fb.maxLength': { en: 'Max Length', he: 'אורך מקסימלי' },
  'fb.description': { en: 'Description', he: 'תיאור' },
  'fb.showFlag': { en: 'Show 🚩 icon', he: 'הצג סמל 🚩' },
  'fb.multiSelect': { en: 'Multi-select', he: 'בחירה מרובה' },
  'fb.addOption': { en: 'Add option…', he: 'הוסף אפשרות…' },
  'fb.box': { en: 'Box', he: 'תיבה' },
  'fb.label': { en: 'Label', he: 'תווית' },
  'fb.egLabel': { en: 'e.g. Leadership Potential', he: 'לדוגמה: פוטנציאל מנהיגות' },
  'fb.score': { en: 'Score', he: 'ציון' },
  'fb.saved': { en: 'Template saved to bank successfully.', he: 'הטופס נשמר בבנק.' },
  'fb.nameRequired': { en: 'Form name is required before saving.', he: 'יש להזין שם טופס לפני השמירה.' },
  'fb.flag.sortable': { en: 'Sortable (drag-and-drop)', he: 'ניתן למיון (גרירה)' },
  'fb.flag.adjustable': { en: 'Adjustable (add/remove candidates)', he: 'ניתן להתאמה (הוספה/הסרה של מועמדים)' },
  'fb.flag.submitRanking': { en: 'Submit Ranking', he: 'שליחת דירוג' },
  'fb.flag.showByName': { en: 'Show by Name (not number)', he: 'הצג לפי שם (לא מספר)' },
  'fb.flag.singleSubmission': { en: 'Single Submission', he: 'הגשה יחידה' },
  'fb.titlePage': { en: 'Form Builder', he: 'בונה טפסים' },
  'fb.editingBank': { en: 'Editing bank form', he: 'עריכת טופס מהבנק' },
  'fb.newForm': { en: 'New Form', he: 'טופס חדש' },
  'fb.tab.bank': { en: 'Forms Bank', he: 'בנק טפסים' },
  'fb.tpl.generic': { en: '📋 Assessment', he: '📋 הערכה' },
  'fb.tpl.interview': { en: '🎯 Interview', he: '🎯 ראיון' },
  'fb.tpl.socio': { en: '🤝 Sociometric', he: '🤝 סוציומטרי' },
  'fb.definition': { en: 'Form Definition', he: 'הגדרת טופס' },
  'fb.name': { en: 'Form Name', he: 'שם הטופס' },
  'fb.egName': { en: 'e.g. Assessment Form', he: 'לדוגמה: טופס הערכה' },
  'fb.type': { en: 'Form Type', he: 'סוג טופס' },
  'fb.mandatory': { en: 'Mandatory for closure', he: 'חובה לסגירה' },
  'fb.roles': { en: 'Role Relevancy', he: 'תפקידים רלוונטיים' },
  'fb.structure': { en: 'Structure / Display', he: 'מבנה / תצוגה' },
  'fb.icon': { en: 'Icon (emoji)', he: 'סמל (אימוג׳י)' },
  'fb.displayTitle': { en: 'Display Title', he: 'כותרת לתצוגה' },
  'fb.displayTitleHint': { en: 'Shown to mobile users', he: 'מוצג למשתמשי האפליקציה' },
  'fb.descriptionHint': { en: 'Subtitle shown on form card', he: 'כותרת משנה בכרטיס הטופס' },
  'fb.flag': { en: 'Flag', he: 'דגל' },
  'fb.addBox': { en: 'Add Box', he: 'הוסף תיבה' },
  'fb.noBoxes': { en: 'No boxes yet — add one above', he: 'אין תיבות עדיין — הוסף תיבה למעלה' },
  'fb.loadingBank': { en: 'Loading bank forms…', he: 'טוען טפסים מהבנק…' },
  'fb.noBank': { en: 'No bank forms yet', he: 'אין עדיין טפסים בבנק' },
  'fb.deleteTitle': { en: 'Delete Bank Form', he: 'מחיקת טופס מהבנק' },
  'fb.fields': { en: 'Form Fields', he: 'שדות הטופס' },
  'fb.socioBoxes': { en: 'Socio Boxes', he: 'תיבות סוציו' },

  // ── Command center / cycles (extra) ──────────────────────────────────────
  'cc.tier.all': { en: 'All', he: 'הכל' },
  'cc.tier.top': { en: 'Top', he: 'עליון' },
  'cc.tier.mid': { en: 'Mid', he: 'אמצע' },
  'cc.tier.bottom': { en: 'Bottom', he: 'תחתון' },
  'cc.status.withdrawn': { en: 'Withdrawn', he: 'פרש' },
  'cyc.exists': { en: 'A cycle for {month} already exists. Please choose a different month/year.', he: 'כבר קיים מחזור עבור {month}. יש לבחור חודש/שנה אחרים.' },
  'cyc.activeExists': { en: 'Cannot activate cycle. There is already an active cycle: "{name}" ({month}). Please close it first.', he: 'לא ניתן להפעיל את המחזור. כבר קיים מחזור פעיל: "{name}" ({month}). יש לסגור אותו קודם.' },

  // ── Cycles page ─────────────────────────────────────────
  'cyc.egName': { en: 'e.g. Spring Cohort 2026', he: 'לדוגמה: מחזור אביב 2026' },
  'cyc.egNumber': { en: 'e.g. 101', he: 'לדוגמה: 101' },
  'cyc.egTeam': { en: 'e.g. 1', he: 'לדוגמה: 1' },

  // ── Summary page ─────────────────────────────────────────
  'sum.csvNeedsNumber': { en: 'CSV must have a "candidateNumber" column', he: 'קובץ ה-CSV חייב לכלול עמודת "candidateNumber"' },
  'sum.errorLoad': { en: 'Error loading cycle data', he: 'שגיאה בטעינת נתוני המחזור' },
  'sum.exportCsv': { en: 'Export CSV', he: 'ייצוא CSV' },
  'sum.exportJson': { en: 'Export JSON', he: 'ייצוא JSON' },

  // ── Cycles table ─────────────────────────────────────────
  'val.requiredFields': { en: 'Please fill in all required fields', he: 'יש למלא את כל שדות החובה' },
  'cyc.monthFormat': { en: 'Please use MM-YYYY format (e.g., 01-2024, 12-2023)', he: 'יש להשתמש בפורמט MM-YYYY (לדוגמה 01-2024, 12-2023)' },
  'cyc.monthFuture': { en: 'Month/Year must be current month or in the future', he: 'החודש/שנה חייבים להיות החודש הנוכחי או בעתיד' },
  'cyc.startInvalid': { en: 'Please enter a valid start date', he: 'יש להזין תאריך התחלה תקין' },
  'cyc.startFuture': { en: 'Start date must be today or in the future', he: 'תאריך ההתחלה חייב להיות היום או בעתיד' },
  'cyc.confirmDelete': { en: 'Are you sure you want to delete this cycle?', he: 'למחוק את המחזור?' },
  'cyc.confirmClose': { en: 'Are you sure you want to close this cycle? This action cannot be undone.', he: 'לסגור את המחזור? לא ניתן לבטל פעולה זו.' },
  'cyc.confirmActivate': { en: 'Are you sure you want to activate this cycle?', he: 'להפעיל את המחזור?' },
  'cyc.loading': { en: 'Loading cycles...', he: 'טוען מחזורים...' },
  'cyc.errorLoad': { en: 'Error loading cycles', he: 'שגיאה בטעינת מחזורים' },
  'cyc.add': { en: 'Add Cycle', he: 'הוסף מחזור' },
  'cyc.displayName': { en: 'Display Name', he: 'שם לתצוגה' },
  'cyc.monthYear': { en: 'Month/Year (MM-YYYY)', he: 'חודש/שנה (MM-YYYY)' },
  'cyc.startDate': { en: 'Start Date', he: 'תאריך התחלה' },

  // ── Candidates table ─────────────────────────────────────────
  'cand.gibushCompleted': { en: 'Gibush Completed', he: 'סיים גיבוש' },
  'cand.gibushIncompleted': { en: 'Gibush Incompleted', he: 'לא סיים גיבוש' },

  // ── Command center ─────────────────────────────────────────
  'cc.tier': { en: 'Tier', he: 'רובד' },
  'cc.search': { en: 'Search', he: 'חיפוש' },
  'cc.searchHint': { en: 'Name or number… ⌘K', he: 'שם או מספר… ⌘K' },
  'cc.allStatuses': { en: 'All statuses', he: 'כל הסטטוסים' },
  'cc.status.active': { en: 'Active', he: 'פעיל' },
  'cc.status.completed': { en: 'Completed', he: 'סיים' },
  'cc.status.incomplete': { en: 'Incomplete', he: 'לא סיים' },
  'cc.allTeams': { en: 'All teams', he: 'כל הצוותים' },
  'cc.allEvaluators': { en: 'All evaluators', he: 'כל המעריכים' },
  'cc.cycle': { en: 'Cycle', he: 'מחזור' },
  'cc.selectCycle': { en: 'Select cycle…', he: 'בחר מחזור…' },
  'cc.team': { en: 'Team', he: 'צוות' },
  'cc.evaluator': { en: 'Evaluator', he: 'מעריך' },

  // ── Candidate list panel ─────────────────────────────────────────
  'cc.expandSidebar': { en: 'Expand sidebar', he: 'הרחב סרגל צד' },
  'cc.collapseSidebar': { en: 'Collapse sidebar', he: 'כווץ סרגל צד' },

  // ── Command center table ─────────────────────────────────────────
  'cc.noMatch': { en: 'No candidates match the current filters.', he: 'אין מועמדים שתואמים את הסינון.' },
  'cc.candidate': { en: 'Candidate', he: 'מועמד' },
  'cc.rank': { en: 'Rank', he: 'דירוג' },
  'cc.flags': { en: 'Flags', he: 'דגלים' },

  // ── Header ─────────────────────────────────────────
  'hdr.account': { en: 'account of current user', he: 'חשבון המשתמש הנוכחי' },
  'hdr.logout': { en: 'Logout', he: 'התנתק' },

  // ── Language switcher ─────────────────────────────────────────
  'hdr.toggleLang': { en: 'Toggle language', he: 'החלף שפה' },

  // ── Protected route ─────────────────────────────────────────
  'auth.authenticating': { en: 'Authenticating...', he: 'מאמת...' },

  // ── Error alert ─────────────────────────────────────────
  'err.contactAdmin': { en: 'Contact your administrator if you believe you should have access to this feature.', he: 'אם לדעתך אמורה להיות לך גישה לתכונה זו, פנה למנהל המערכת.' },

  // ── Users table ─────────────────────────────────────────
  'usr.passwordRequired': { en: 'Password is required for new users', he: 'יש להזין סיסמה למשתמש חדש' },
  'usr.confirmDelete': { en: 'Are you sure you want to delete this user?', he: 'למחוק את המשתמש?' },
  'usr.loading': { en: 'Loading users...', he: 'טוען משתמשים...' },
  'usr.errorLoad': { en: 'Error loading users', he: 'שגיאה בטעינת משתמשים' },
  'usr.add': { en: 'Add User', he: 'הוסף משתמש' },
  'usr.firstName': { en: 'First Name', he: 'שם פרטי' },
  'usr.lastName': { en: 'Last Name', he: 'שם משפחה' },

  // ── Team assignments ─────────────────────────────────────────
  'ta.cannotRemove': { en: 'Team assignments cannot be removed once created — contact your database administrator if removal is needed.', he: 'לא ניתן להסיר שיבוצי צוות לאחר יצירתם — לצורך הסרה פנה למנהל מסד הנתונים.' },
  'sum.merged': { en: 'Merged {n} records with {cols} extra column(s). Export JSON to persist.', he: 'מוזגו {n} רשומות עם {cols} עמודות נוספות. ייצא JSON כדי לשמור.' },
  'sum.imagesLoaded': { en: 'Loaded {n} candidate image(s)', he: 'נטענו {n} תמונות מועמדים' },
  'sum.imagesSkipped': { en: '({n} file(s) skipped)', he: '({n} קבצים דולגו)' },
  'sum.exportedCsv': { en: 'Exported {n} candidates × {cols} columns', he: 'יוצאו {n} מועמדים × {cols} עמודות' },
  'sum.exportFailed': { en: 'Export failed', he: 'הייצוא נכשל' },
  'sum.exportedJson': { en: 'Exported {n} candidates as JSON', he: 'יוצאו {n} מועמדים כ-JSON' },
  'sum.exportJsonFailed': { en: 'JSON export failed', he: 'ייצוא JSON נכשל' },
  'sum.unknownError': { en: 'Unknown error', he: 'שגיאה לא ידועה' },
  'cyc.monthHint': { en: 'Type digits only - dash will be added automatically', he: 'הקלד ספרות בלבד - המקף יתווסף אוטומטית' },
  'ta.teamNumberInvalid': { en: 'Team number must be a positive integer', he: 'מספר הצוות חייב להיות מספר שלם חיובי' },

  // ── Cycle status ──────────────────────────────────────────────────────────
  'cycleStatus.draft':   { en: 'Draft',  he: 'טיוטה' },
  'cycleStatus.active':  { en: 'Active', he: 'פעיל' },
  'cycleStatus.closed':  { en: 'Closed', he: 'סגור' },
} as const;

export type TKey = keyof typeof T;

export function translate(key: TKey, lang: AppLang): string {
  return T[key][lang];
}

/** For labels built from data (roles, form types): the translation when one exists, else `fallback`. */
export function translateOr(key: string, lang: AppLang, fallback: string): string {
  return (T as Record<string, { en: string; he: string }>)[key]?.[lang] ?? fallback;
}
